import InfiniteLoadBtn from 'components/InfiniteLoadBtn/InfiniteLoadBtn'

export default InfiniteLoadBtn
